export const folder_closed = {
	name: 'folder-closed',
	title: 'Folder Closed',
	content:
		'<path d="M23.25,6.75a1.5,1.5,0,0,0-1.5-1.5H10.5L8.7,2.85a1.5,1.5,0,0,0-1.2-.6H2.25a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>',
};
